/* eslint-disable radix */
import React, {Component} from 'react';
import {Table} from 'antd';

import './index.less';

// 对象内容的可视区的宽度 或高度，不包滚动条等边线，会随对象显示大小的变化而改变
function getClientStyle(type) {
  let value = 0;
  if (document.body[type] && document.documentElement[type]) {
    value =
      document.body[type] < document.documentElement[type]
        ? document.body[type]
        : document.documentElement[type];
  } else {
    value =
      document.body[type] > document.documentElement[type]
        ? document.body[type]
        : document.documentElement[type];
  }
  return value;
}

const commonTable = WrappedComponent => {
  return class extends Component {
    constructor(props) {
      super(props);

      this.state = {
        scroll: {},
        pagination: {
          pageSize: 20,
          pageSizeOptions: ['10', '20', '30', '50', '100'],
          size: 'small',
          showSizeChanger: true,
          showQuickJumper: true,
        },
      };
      this.pageWidth = 1366; // 大小屏分界点
    }

    componentDidMount() {
      this.setScroll();
      window.addEventListener('resize', this.setScroll);
    }

    componentWillReceiveProps(nextProps) {
      const {scroll, extraHeight, dataSource} = this.props;
      const {
        scroll: nextScroll,
        extraHeight: nextExtraHeight,
        dataSource: nextDataSource,
      } =
        nextProps || {};

      if (
        nextDataSource !== dataSource ||
        nextScroll !== scroll ||
        nextExtraHeight !== extraHeight
      ) {
        this.setScroll();
      }
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.setScroll);
    }

    setScroll = () => {
      const {scroll, extraHeight = 0, dataSource} = this.props;
      const clientWidth = Math.ceil(getClientStyle('clientWidth'));
      const clientHeight = Math.ceil(getClientStyle('clientHeight'));

      let scrollY = clientHeight - 60 - 10 - 53 - 60 - 40 - extraHeight; // 头部导航+内容间隙+title+pagination+tableHeader+extraHeight;
      // 判断是否有查询区
      const isHasSearch = document.getElementsByClassName('filter-warp')[0];

      if (isHasSearch) {
        scrollY -= 52;
      }
      if (clientWidth > this.pageWidth) {
        scrollY -= 25;
      }

      // 当没有数据的时候不设置scrollY
      if (dataSource instanceof Array && dataSource.length > 0) {
        this.setState({
          scroll: {y: scrollY >= 48 ? scrollY : 48, ...scroll},
        });
      } else {
        this.setState({
          scroll: {...scroll},
        });
      }
    };

    render() {
      const {pagination: statePagination, scroll} = this.state;
      const {pagination: propsPagination} = this.props;
      const mergePagination = {
        ...statePagination,
        ...propsPagination,
      };

      return (
        <WrappedComponent
          size="small"
          {...this.props}
          pagination={mergePagination}
          scroll={scroll}
        />
      );
    }
  };
};

export default commonTable(Table);
